import Vue from 'vue'
import Vuex from 'vuex'
import home from './modules/home'
import user from './modules/user'
import userno from './modules/userno'
import asyncRouter from './modules/asyncRouter'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    home,
    user,
    userno,
    asyncRouter
  },
  getters
})

export default store
